<template>
  <div class="peoplechoice">
    <Header :title="$t('m.BroadcastPoll')"></Header>
    <div class="serch bgc3">
      <span style="float:left">
        <div class>
          <span>{{$t('m.PlsEnterPollInterval')}}</span>
          <InputNumber :min="10" :max="86400" v-model="pollinginterval"></InputNumber>
          <span>{{$t('m.Second')}}</span>
        </div>
      </span>
    </div>
    <div class="choice">{{choice}}</div>
    <div class="main">
      <CheckboxGroup v-model="avalibleterminal">
        <div :key="index" class="mainitem" v-for="(item,index) in array">
          <div :index="item.key" class="title spebgc">{{item.key}}</div>
          <div class="content">
            <div :key="mindex" class="contentitem" v-for="(mitem,mindex) in item.array">
              <!--            <span>-->
              <Checkbox :label="JSON.stringify(mitem)">
                <span class="headerpicwarp">
                  <Icon type="ios-contacts" />
                </span>
                <span
                  style="line-height:0.41rem;width:1.3rem;display:inline-block;margin-left:0.05rem;font-size:0.14rem; word-break:keep-all;white-space:nowrap;text-overflow:ellipsis"
                >{{mitem.party_name}}</span>
              </Checkbox>
              <!--            </span>-->
            </div>
          </div>
        </div>
      </CheckboxGroup>
    </div>
    <div @click="sure" class="bottom bgc">{{$t('m.OKBtn')}}</div>
  </div>
</template>
<script>
import Header from "../header/header";
import {
  broadcastPolling,
  getTerminalsOfCf,
  terminalList
} from "../../assets/js/url";

export default {
  name: "peoplechoice",
  data() {
    return {
      avalibleterminal: [],
      array: [],
      data: Object,
      myset: [],
      searchcontent: "",
      meetinguuid: "",
      cf_id: "",
      mcu_id: "",
      departmentId: "",
      usermessage: Object,
      popshow: false,
      pollinginterval: 10,
      parentmcuId: "",
      meetingId: ""
    };
  },
  components: {
    Header
  },
  activated() {
    this.avalibleterminal = [];
    if (this.$route.query.meetinguuid) {
      this.meetinguuid = this.$route.query.meetinguuid;
      this.cf_id = this.$route.query.cf_id;
      this.mcu_id = this.$route.query.mcuId;
      this.meetingId = this.$route.query.meetingId;
    } else {
      this.$router.push("/index");
    }
    this.terminallistfilter();
  },
  methods: {
    search() {
      if (this.searchcontent) {
        $(".title").css("display", "none");
        $(".contentitem").css("display", "none");
        $(
          ".contentitem:contains(" + this.searchcontent.toLowerCase() + ")"
        ).css("display", "block");
      } else {
        $(".title").css("display", "block");
        $(".contentitem").css("display", "block");
      }
    },
    terminallistfilter() {
      this.$loadingshow();
      this.array = [];
      this.$http
        .post(getTerminalsOfCf, {
          mcu_id: this.mcu_id,
          cf_id: this.cf_id
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              const data = res.data.data.cf_party;
              this.parentmcuId = res.data.data.mcuId;
              const mymap = new Map();
              const hasname = [];

              const hasdepartment = [];
              const set = data.map(function(item, index) {
                if ("party_id" in item && "party_name" in item) {
                  mymap.set(item.id, item.party_name);
                }
                if ("party_name" in item) {
                  hasname.push(item.party_name);
                }
                if ("departmentName" in item) {
                  hasdepartment.push(item.departmentName);
                }
                if ("departmentName" in item) {
                  item.key = item.departmentName;
                  return item.departmentName;
                }
              });
              this.data = mymap;
              const myset = new Set(set);
              const key = Array.from(myset).sort();
              this.myset = key;
              this.array = [];
              for (let i = 0; i < key.length; i++) {
                this.array.push({
                  key: key[i],
                  array: data
                    .filter(function(item, index) {
                      return item.key == key[i];
                    })
                    .sort()
                });
              }
            } else {
              this.$toast(this.$t('m.TerminalListGetFail'));
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.NetworkException'));
          }
        );
    },
    sure() {
      if (this.avalibleterminal.length === 0) {
        this.$toast(this.$t('m.PlsSelectTerminal'));
        return;
      }

      let dataArray = [];
      let testArr = [];
      for (let i = 0; i < this.avalibleterminal.length; i++) {
        testArr.push(JSON.parse(this.avalibleterminal[i]));
      }
      for (let i = 0; i < testArr.length; i++) {
        dataArray.push({
          subMcuId: testArr[i].mcuId,
          cfId: testArr[i].cf_id,
          terminal: testArr[i].party_id, // terminal为partyid
          name: testArr[i].party_name
        });
      }
      this.$http
        .post(broadcastPolling, {
          //用户名
          useruuid: window.sessionStorage.getItem("UUID"),
          id: this.meetingId,
          time: this.pollinginterval,
          action: 1, // 1为开始广播轮询
          terminalsJson: JSON.stringify(dataArray)
        })
        .then(
          res => {
            if (res.data.status === 2000) {
              this.$toast(this.$t('m.BroadcastPollStartOK'));
            } else {
              this.$toast(this.$t('m.BroadcastPollStartFail'));
            }
            this.$router.push({
              path: "/meetingact",
              query: {
                cf_id: this.cf_id,
                mcuId: this.mcu_id
              }
            });
          },
          err => {
            this.roomchooseshow = false;
            this.$toast(this.$t('m.BroadcastPollStartFail'));
          }
        );
    }
  },
  computed: {
    choice() {
      return " ";
    }
  }
};
</script>
<style scoped>
.peoplechoice {
  width: 100%;
}

.serch {
  height: 0.52rem;
  line-height: 0.52rem;
  padding: 0 0.15rem;
  font-size: 0.15rem;
  width: 100%;
  position: fixed;
  top: 0.44rem;
  left: 0;
  background-color: #fff;
  z-index: 100;
  border-bottom: 1px solid #ddd;
}

.choice {
  padding: 0.15rem 0.45rem 0.05rem 0.15rem;
  line-height: 0.3rem;
  padding-top: 0.5rem;
}

.serchbox {
  width: 1.8rem;
  height: 0.32rem;
  line-height: 0.32rem;
  display: inline-block;
  margin-top: 0.1rem;
  border-radius: 5px;
  border: 1px solid #ddd;
  /* float: left; */
  margin-right: 0.1rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
}

.searchinput {
  width: 1.2rem;
  height: 0.32rem;
  border: none;
  background-color: transparent;
  outline: none;
  line-height: 0.32rem;
}

i {
  font-size: 0.2rem;
}

.title {
  padding: 0 0.15rem;
  height: 0.28rem;
  background-color: #f8f8f8;
  line-height: 0.28rem;
  font-size: 0.16rem;
  font-weight: bold;
}

.contentitem {
  height: 0.41rem;
  font-size: 0.16rem;
  line-height: 0.41rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.main {
  padding: 0 0 0.5rem;
}

.content {
  padding: 0rem 0.15rem;
  line-height: 0.2rem;
}

.bottom {
  width: 100%;
  height: 0.49rem;
  line-height: 0.49rem;
  color: #fff;
  font-size: 0.18rem;
  text-align: center;
  position: fixed;
  bottom: 0px;
  left: 0px;
}

.right {
  position: fixed;
  top: 1rem;
  right: 0px;
  width: 0.38rem;
  background-color: #fff;
  padding: 0;
  height: 75vh;
  overflow-y: scroll;
}

.right span {
  width: 100%;
  line-height: 0.16rem;
  display: inline-block;
  text-align: center;
}

.headerpicwarp {
  display: inline-block;
  width: 0.35rem;
  height: 0.41rem;
  line-height: 0.41rem;
  text-align: center;
  /*float: left;*/
}

.headerpic {
  width: 0.35rem;
  height: 0.35rem;
  vertical-align: middle;
  float: left;
}

.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.templatepop {
  width: 3rem;
  height: 3.6rem;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -1.8rem;
  margin-left: -1.5rem;
  box-sizing: border-box;
  padding: 0.4rem 0;
  font-size: 0.15rem;
}

.popclosex {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
}

.leftspan {
  display: inline-block;
  width: 0.5rem;
  text-align: center;
  margin-left: 0.2rem;
}
</style>




// WEBPACK FOOTER //
// src/components/content/broadcastpolling.vue